// controllers/select_controller.js
import { Controller } from "@hotwired/stimulus"

export default class SelectController extends Controller {
  static targets = ["trigger", "dropdown", "selectedText", "selectedSubtext","hiddenInput", "chevron"]
  static values = { name: String, placeholder: String }

  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.boundHandleClickOutside)

    // Ensure placeholder/selected styling is correct on first render (e.g. preview mode)
    this.syncSelectedTextStyle()
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside)
  }

  toggle(event) {
    event.stopPropagation()

    if (!this.hasDropdownTarget) return

    // Close all other select dropdowns first
    this.closeOtherDropdowns()

    // Toggle this dropdown
    this.dropdownTarget.classList.toggle("hidden")
    if (this.hasChevronTarget) this.chevronTarget.classList.toggle("rotate-180")
  }

  select(event) {
    const displayText = event.params.display
    const subtext = event.params.subtext
    const value = event.params.value

    this.selectedTextTarget.textContent = displayText

    if (this.hasSelectedSubtextTarget) {
      this.selectedSubtextTarget.textContent = subtext
    }

    this.hiddenInputTarget.value = value
    this.hiddenInputTarget.name = this.nameValue

    this.syncSelectedTextStyle(displayText, value)

    this.close()

    this.hiddenInputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  close() {
    if (!this.hasDropdownTarget) return
    this.dropdownTarget.classList.add("hidden")
    if (this.hasChevronTarget) this.chevronTarget.classList.remove("rotate-180")
  }

  closeOtherDropdowns() {
    // Find all other select controllers and close their dropdowns
    document.querySelectorAll('[data-controller*="select"]').forEach(element => {
      if (element !== this.element) {
        const controller = this.application.getControllerForElementAndIdentifier(element, "select")
        if (controller?.close) {
          controller.close()
        }
      }
    })
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  syncSelectedTextStyle(displayTextParam, valueParam) {
    if (!this.hasSelectedTextTarget) return;

    const displayText = displayTextParam ?? this.selectedTextTarget.textContent?.trim() ?? ""
    const value = valueParam ?? (this.hasHiddenInputTarget ? this.hiddenInputTarget.value : "")

    const placeholderMatches = this.hasPlaceholderValue && displayText === this.placeholderValue
    const isPlaceholder = placeholderMatches || (displayText === "" && value === "")

    const usesInputIconTokens =
      this.selectedTextTarget.classList.contains("dark:text-dark-input-icon-and-text") ||
      this.selectedTextTarget.classList.contains("wdark:text-wdark-input-icon-and-text") ||
      this.selectedTextTarget.classList.contains("dark:text-dark-input-icon-and-text-secondary") ||
      this.selectedTextTarget.classList.contains("wdark:text-wdark-input-icon-and-text-secondary") ||
      this.hasPlaceholderValue

    if (!usesInputIconTokens) return

    if (isPlaceholder) {
      this.selectedTextTarget.classList.remove(
        "dark:text-dark-input-icon-and-text", "wdark:text-wdark-input-icon-and-text"
      )
      this.selectedTextTarget.classList.add(
        "dark:text-dark-input-icon-and-text-secondary", "wdark:text-wdark-input-icon-and-text-secondary"
      )
    } else {
      this.selectedTextTarget.classList.remove(
        "dark:text-dark-input-icon-and-text-secondary", "wdark:text-wdark-input-icon-and-text-secondary"
      )
      this.selectedTextTarget.classList.add(
        "dark:text-dark-input-icon-and-text", "wdark:text-wdark-input-icon-and-text"
      )
    }
  }
}